import React, { useState } from "react";
import { Slider, InputNumber, Space } from "antd";
export default function SliderInput(props) {

    const { onBeforeChange = () => { }, suffix="", onAfterChange = () => { }, value = 0, disabled = false, width = 130, min = 0, max = 100, onChange = () => { } } = props;


    const validate = (_v) => {
        if (isNaN(_v)) { return; }
        onChange(_v);
    }
    const formatter = (value) => `${value}px`;

    return (
        <div className="float-flex">
            <Slider
                onBeforeChange={onBeforeChange}
                onAfterChange={onAfterChange}
                style={{ "width": width + "px" }}
                min={min}
                disabled={disabled}
                max={max}
                tooltip={{
                    formatter,
                }}
                onChange={(_v) => validate(_v)}
                value={value}
            />
            <Space size={0}>
            <InputNumber
                className="simple-num-input"
                min={min}
                max={max}
                style={{ margin: '0 16px', "width": "40px" }}
                value={value}
                onBlur={(e) => validate(e.target.value)}
                onChange={onChange}
                controls={false}
                precision={0}
            />
            {(suffix && <div style={{"marginLeft" : "-10px", "marginRight" : "10px"}} className="simple-label">PX</div>)}
            </Space>
        </div>
    )
}